var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import useSWR from 'swr';
import { fetchUms } from '@dev-togetherprice/api.services';
import { getAuthorizationToken } from '@dev-togetherprice/api.auth';
const fetchApplicationSetting = (url) => __awaiter(void 0, void 0, void 0, function* () {
    if (yield getAuthorizationToken()) {
        return fetchUms(url);
    }
    return {
        mobileBandwidthSavings: false,
    };
});
export const useApplicationSettings = () => useSWR('/getApplicationSettings', fetchApplicationSetting, {
    suspense: true,
    dedupingInterval: 300,
    revalidateOnMount: true,
    revalidateOnFocus: true,
    revalidateOnReconnect: true,
    shouldRetryOnError: false,
}).data;
export const useUserRiskManagement = () => useSWR('/getRiskManagementStatus', fetchUms, {
    suspense: true,
    dedupingInterval: 300,
    revalidateOnMount: true,
    revalidateOnFocus: true,
    revalidateOnReconnect: true,
    shouldRetryOnError: false,
}).data;
